// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".nun04{display:-ms-flexbox;display:flex;-ms-flex-flow:row wrap;flex-flow:row wrap;-ms-flex-align:baseline;align-items:baseline}.nun04 .row{-ms-flex-preferred-size:100%;flex-basis:100%;-ms-flex-align:baseline;align-items:baseline;-webkit-column-gap:30px;-moz-column-gap:30px;column-gap:30px;margin-left:0;margin-right:0}.nun04 .col,.nun04 .col-6{padding-left:0;padding-right:0}.nun04 .col-6{-ms-flex-preferred-size:calc(50% - 15px);flex-basis:calc(50% - 15px)}", ""]);
// Exports
exports.locals = {
	"addCountryForm": "nun04"
};
module.exports = exports;
